/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hide_PasswordInputs */

const es_cap_hide_password = /** @type {(inputs: Cap_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar contraseña`)
};

const gl_cap_hide_password = /** @type {(inputs: Cap_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar contrasinal`)
};

const en_cap_hide_password = /** @type {(inputs: Cap_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

/**
* | output |
* | --- |
* | "Hide password" |
*
* @param {Cap_Hide_PasswordInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hide_password = /** @type {((inputs?: Cap_Hide_PasswordInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hide_PasswordInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hide_password(inputs)
	if (locale === "en") return en_cap_hide_password(inputs)
	return es_cap_hide_password(inputs)
});